"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M14.835 6.128A.5.5 0 0 0 14 6.5v2.049c-2.593.299-4.505 1.085-6.045 2.48-1.613 1.46-2.772 3.544-3.916 6.278a.5.5 0 0 0 .823.538c1.456-1.531 2.668-2.535 4.098-3.2 1.326-.615 2.875-.955 5.04-1.112V15.5a.5.5 0 0 0 .835.372l5-4.5a.5.5 0 0 0 0-.744z"
}), 'ShareFilled');
